function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  & .ant-dropdown-menu {\n    max-height: 600px;\n    overflow-y: auto;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 0;\n  height: unset;\n  border: none;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "Edit"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
import { Button as AntButton, Checkbox, Dropdown as AntDropdown } from "antd";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import { t } from "ttag";
var Dropdown = styled(AntDropdown)(_templateObject());
// Keep the button from increasing the size of the whole heading row
var Button = styled(AntButton)(_templateObject1());
var EDIT_COLUMN_KEY = "edit-column-dropdown";
var defaultVisibleColumnOptions = {
    enabled: true,
    defaultVisibleColumns: null,
    omitColumns: [
        "reorder"
    ],
    disabledColumns: [],
    columnTitles: {}
};
function useVisibleColumns(columns, options) {
    var opts = _objectSpread({}, defaultVisibleColumnOptions, options);
    var _opts_defaultVisibleColumns;
    var _useState = _slicedToArray(useState(function() {
        return (_opts_defaultVisibleColumns = opts.defaultVisibleColumns) !== null && _opts_defaultVisibleColumns !== void 0 ? _opts_defaultVisibleColumns : columns.map(function(col) {
            return col.key;
        });
    }), 2), visibleKeys = _useState[0], setVisibleKeys = _useState[1];
    var _useState1 = _slicedToArray(useState(false), 2), editOpen = _useState1[0], setEditOpen = _useState1[1];
    // This useEffect is for prop validation in development env
    useEffect(function() {
        if (process.env.NODE_ENV !== "production" && opts.enabled) {
            if (columns.some(function(col) {
                return !col.key;
            })) {
                // eslint-disable-next-line no-console
                console.warn("[useVisibleColumns] All columns must have a key.");
            }
            if (columns.find(function(col) {
                return col.key === EDIT_COLUMN_KEY;
            })) {
                // eslint-disable-next-line no-console
                console.warn('[useVisibleColumns] Column key "'.concat(EDIT_COLUMN_KEY, '" is reserved.'));
            }
        }
    }, [
        columns,
        opts.enabled
    ]);
    var onChange = useCallback(function(event) {
        var value = event.target.value;
        setVisibleKeys(function(prev) {
            return prev.includes(value) ? prev.filter(function(key) {
                return key !== value;
            }) : _toConsumableArray(prev).concat([
                value
            ]);
        });
    }, []);
    var _opts_columnTitles_column_key;
    var editColumn = useMemo(function() {
        return {
            key: EDIT_COLUMN_KEY,
            align: "center",
            width: 100,
            render: function() {
                return null;
            },
            title: /*#__PURE__*/ React.createElement(Dropdown, {
                trigger: [
                    "click"
                ],
                open: editOpen,
                onOpenChange: function(value) {
                    return setEditOpen(value);
                },
                menu: {
                    items: columns.filter(function(column) {
                        return !opts.omitColumns.includes(column.key);
                    }).map(function(column) {
                        var _opts_disabledColumns;
                        return {
                            key: column.key,
                            label: /*#__PURE__*/ React.createElement(Checkbox, {
                                key: column.key,
                                checked: visibleKeys.includes(column.key),
                                value: column.key,
                                disabled: (_opts_disabledColumns = opts.disabledColumns) === null || _opts_disabledColumns === void 0 ? void 0 : _opts_disabledColumns.includes(column.key),
                                onChange: onChange
                            }, ((_opts_columnTitles_column_key = opts.columnTitles[column.key]) !== null && _opts_columnTitles_column_key !== void 0 ? _opts_columnTitles_column_key : column.title) || column.key)
                        };
                    })
                }
            }, /*#__PURE__*/ React.createElement(Button, {
                type: "link"
            }, t(_templateObject2())))
        };
    }, [
        columns,
        visibleKeys,
        editOpen,
        opts.omitColumns,
        opts.disabledColumns,
        opts.columnTitles,
        onChange
    ]);
    var filteredColumns = useMemo(function() {
        return _toConsumableArray(columns.filter(function(col) {
            return _toConsumableArray(opts.omitColumns).concat(_toConsumableArray(visibleKeys)).includes(col.key);
        })).concat([
            editColumn
        ]);
    }, [
        columns,
        opts.omitColumns,
        visibleKeys,
        editColumn
    ]);
    return opts.enabled ? filteredColumns : columns;
}
export default useVisibleColumns;
